<div id="topBanner">
    <img id="logo" src="/images/laqorr_title.png" />
    <button
        *ngIf="canLaunch$ | async" 
        (click)="launchPlayer()"
        #launchPlayerButton>
        Launch
    </button>
    </div>